'use strict';

angular.module('app.common')

.directive('runlistSearchButton',['uuid','LoggerApi', function(uuid,loggerApiService) {
	return {
		restrict: 'E',
		scope: true,
		templateUrl: 'app/common/directives/runlistsearchbutton/runlistSearchButton.html',
		link: function(scope, element, attrs) {

			scope.gaEventPagename = attrs.gaEventPagename + ' Page';

			scope.clickedRunlist = function (page_from) {
				var _uuid = uuid.v4();
				loggerApiService.applicationEvent(3, "form1", "", "*","SearchResult","",_uuid);
				loggerApiService.applicationEventAddEvent("clicked", page_from);
				loggerApiService.applicationEventStart();
			};
		}
	}
}]);



// WEBPACK FOOTER //
// ./app/common/directives/runlistsearchbutton/runlistSearchButtonDirective.js